export default function SciPy_Matlab_Arrays() {
  return (
    <div>
      <h1>SciPy Matlab Arrays</h1>
    </div>
  );
}
